<template>
  <div class="main-header_container">
    <div class="main-header__half--left">
      <h1 class="logo">
        <router-link to="/dashboard">
          <img
            src="/static/images/logo-alvaro-interna.svg"
            alt="Laboratório Alvaro"
          />
        </router-link>
        <p class="product-name">AOL 2.0</p>
      </h1>
    </div>

    <div class="main-header__half--right">
      <CurrentBalance v-if="toggle.prePaid" />
      <div class="icon-header-decoration">
        <div class="whatsapp_container">
          <a
            class="help-link icon-header-decoration"
            target="_blank"
            @click="pushToWhatsapp()"
          >
            <md-icon
              class="whatsapp-icon"
              md-src="/static/images/icon-whatsapp.svg"
            />
          </a>
        </div>
        <infotip
          id="whatsapp"
          icon="/static/images/icon-whats.svg"
          text="Precisa falar com a gente? Utilize o Whatsapp! Clique aqui e envie sua mensagem!"
          :auto-open-on-first-days="true"
        />
      </div>

      <HelpCenterDropdown v-if="toggle.helpCenterTutorial" />

      <TimeRemainingClock />

      <NotificationButton
        v-if="toggle.notification_view"
        id="notificationContainer"
        :count="getAlertsNumber"
        :expanded="isComunicationSidebarVisible"
        @click="toggleNotifications"
      />
    </div>
    <dropdown-menu />
  </div>
</template>

<script>
import UserProfile from './UserProfile'
import Infotip from '@/components/common/infotip/Infotip'
import { mapActions, mapGetters } from 'vuex'
import UserDropdown from './userDropdown/UserDropdown'
import HelpCenterDropdown from '@/components/HelpCenter/HelpCenterDropdown'
import TimeRemainingClock from '@/components/common/timeRemainingClock'
import CurrentBalance from './CurrentBalance.vue'
import NotificationButton from '@/components/Comunication/NotificationButton.vue'

export default {
  name: 'MainHeader',
  components: {
    'user-profile': UserProfile,
    infotip: Infotip,
    'dropdown-menu': UserDropdown,
    HelpCenterDropdown,
    TimeRemainingClock,
    CurrentBalance,
    NotificationButton,
  },
  computed: {
    ...mapGetters([
      'isComunicationSidebarVisible',
      'getAlertsNumber',
      'isPreferenceVisible',
      'profile',
      'toggle',
    ]),
  },
  beforeDestroy() {
    this.setComunicationSidebarShowOff(false)
  },
  methods: {
    ...mapActions([
      'setComunicationSidebarShowOff',
      'changeTabShowOff',
      'setPreferenceShowOff',
    ]),
    showOffSideBar() {
      this.setComunicationSidebarShowOff(!this.isComunicationSidebarVisible)
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Menu superior',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    pushToWhatsapp() {
      window.open('https://api.whatsapp.com/send?1=pt_BR&phone=5545988219193')
      this.pushEventToAnalytics('Link Whatsapp')
    },
    pushToDownload() {
      this.$router.push('/central-de-ajuda')
      this.pushEventToAnalytics('Link Central de Ajuda')
    },
    showOffPreferences() {
      if (this.isComunicationSidebarVisible) {
        this.setComunicationSidebarShowOff(false)
      }
      this.setPreferenceShowOff(!this.isPreferenceVisible)
    },
    toggleNotifications() {
      const shouldOpen = !this.isComunicationSidebarVisible
      this.changeTabShowOff(false)
      this.setComunicationSidebarShowOff(shouldOpen)
      if (shouldOpen) this.pushEventToAnalytics('Notificações')
      if (this.isPreferenceVisible) this.setPreferenceShowOff(false)
    },
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';
@import '../../../static/stylesheets/mixins';

/* COMPONENT: commom/MainHeader.vue */
.main-header_container {
  background-color: #fff;
  height: $mainHeaderHeight;
  padding: 0 30px 0 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  z-index: 104;
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.1), 0 1px 5px 0 rgba(0, 0, 0, 0.1);

  .main-header__half--left,
  .main-header__half--right {
    flex-grow: 1;
  }

  .main-header__half--left {
    max-width: 225px;
  }

  .logo {
    display: flex;
    align-items: center;

    img {
      border-right: solid 1px #e0e0e0;
      margin-right: 17px;
      padding-right: 11px;
      height: 40px;
      width: 130px;
    }
  }

  .product-name {
    font-weight: 400;
    font-size: 20px;
    line-height: 1.2;
    letter-spacing: -0.3px;
    text-align: left;
    color: #808080;
  }

  .main-header__half--right {
    display: flex;
    flex-direction: row;
    padding-left: 15px;
    align-items: center;
    justify-content: flex-end;
    max-width: calc(100% - 225px);

    @include browser-ie-11 {
      .user-profile {
        width: calc(100% - 360px);
      }
    }

    .user-profile {
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;
      padding-right: 15px;
      // cálculo máximo do tamanho do nome menos o tamanoh dos blocos de download, ajuda e sair
      max-width: calc(100% - 360px);
      min-width: 75px;
    }

    .help-icon,
    .logout-icon {
      color: #840051;
      font-size: 22px;
    }

    .whatsapp-icon {
      width: 30px;
      height: 30px;
      margin: 0 4px !important;
    }

    .help-link {
      position: relative;
      display: inline-block;
    }

    .preference-bar {
      position: relative;
      display: inline-block;
    }

    .preferences-icon {
      padding-bottom: 3px;
      padding-top: 1px;
    }

    .download_container,
    .help-zendesk,
    .icon-header_container {
      color: #840051;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      margin: auto 4px;

      i.md-icon {
        margin: 0 !important;
        text-align: center;
        display: flex;
        justify-content: center;

        > svg {
          fill: #b2b2b2;
        }
      }
    }
    .whatsapp_container {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 5px;
      cursor: pointer;
    }

    .md-icon {
      margin: 0 0 0 15px;
    }

    .download {
      padding: 0 10px 0 5px;
      border-right: solid 2px #e0e0e0;
    }

    .i-donwloads {
      svg,
      path {
        fill: #b2b2b2;
        max-width: 20px;
      }
    }

    .icon-header {
      padding-left: 5px;
    }

    .logout-button {
      padding-left: 5px;
    }
  }

  .icon-header_container,
  .whatsapp_container {
    &:hover {
      border-radius: 4px;
      background-color: rgba(22, 22, 22, 0.04);
    }
  }
}

.icon-header-decoration {
  text-decoration: none !important;

  #infotip-whatsapp {
    transform: translate(-46%, 0.3em);
  }
}
</style>
